import { type StyleXStyles } from '@stylexjs/stylex'
import { useMemo } from 'react'
import { mergeXStyles } from './mergeXStyles'

export type XStyles<Keys extends string> = Record<Keys, StyleXStyles>

/**
 * Merge component xStyles and custom xStyles
 */
export const useXStyles = <Keys extends string>(xStyles: XStyles<Keys>, customXStyles?: Partial<XStyles<Keys>>) => {
  const mergedXStyles = useMemo(
    () => mergeXStyles(xStyles, customXStyles),
    [xStyles, customXStyles],
  )

  return mergedXStyles
}
